import { render, staticRenderFns } from "./studentCategory.vue?vue&type=template&id=fa44da26&scoped=true&"
import script from "./studentCategory.vue?vue&type=script&lang=js&"
export * from "./studentCategory.vue?vue&type=script&lang=js&"
import style0 from "./studentCategory.vue?vue&type=style&index=0&id=fa44da26&lang=scss&scoped=true&"
import style1 from "./studentCategory.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./studentCategory.vue?vue&type=style&index=2&id=fa44da26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa44da26",
  null
  
)

export default component.exports